<template>
  <nav class="mt-[100px] lg:mt-0">
    <ul class="flex flex-col gap-y-[25px] text-[25px]  lg:flex-row lg:gap-x-[18px] lg:text-[14px]">
      <li>
        <nuxt-link @click="onFaqClicked" class="cursor-pointer hover:underline">{{ t('b2b.header.menu.faq') }}</nuxt-link>
      </li>
      <li>
        <nuxt-link :to="localePath('/wellbeing')" class="cursor-pointer hover:underline">{{ t('b2b.header.menu.wellbeing') }}</nuxt-link>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
const { t } = useI18n();
const localePath = useLocalePath()
const model = defineModel()
const router = useRouter()

const onFaqClicked = () => {
  model.value = false;
  router.push(localePath({path: '/', hash: '#faq'}));
}
</script>


